import { render } from "./PhonePart4.vue?vue&type=template&id=6549bcf2&scoped=true"
import script from "./PhonePart4.vue?vue&type=script&lang=js"
export * from "./PhonePart4.vue?vue&type=script&lang=js"

import "./PhonePart4.vue?vue&type=style&index=0&id=6549bcf2&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6549bcf2"]])

export default __exports__